import React from 'react';
import {Button, Input, Modal, Table, message} from 'antd';
import {getNewOutlet, getOutlet, useOutlet} from 'reconnect.js';
import styled from 'styled-components';
import * as Jstorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../../AppActions';
import {formatDateStr} from '../../Utils/TimeUtil';
import {ModalCustomStyle} from '../../AppContext/customStyledCss';

getNewOutlet('admin-search-committee-modal', null, {autoDelete: false});

export function showAdminSearchCommitteeModal(data) {
  getOutlet('admin-search-committee-modal').update(data);
}

const fetchRecords = async (
  keyword,
  columns,
  paging = {offset: 0, limit: 4},
) => {
  try {
    AppActions.setLoading(true);
    return Jstorage.fetchDocuments(
      'Committee',
      {
        $or: columns.map((column) => ({
          [column.key]: {$regex: keyword},
        })),
      },
      null,
      paging,
    );
  } catch (err) {
    message.error('發生錯誤。');
  } finally {
    AppActions.setLoading(false);
  }
};

export default function AdminSearchCommitteeModal(props) {
  const [data, setData] = useOutlet('admin-search-committee-modal');
  const [keyword, setKeyword] = React.useState(null);
  const [records, setRecords] = React.useState(null);
  // const [_selectedRows, _setSelectedRows] = React.useState([]);
  const [pagination, setPagination] = React.useState({
    total: 0,
    pageSize: 4,
  });

  const columns = [
    {
      key: 'NAME',
      title: '名稱',
      dataIndex: 'NAME',
    },
    {
      title: '分類',
      key: 'CATEGORY',
      dataIndex: 'CATEGORY',
      render: (_, record) => {
        const display = (() => {
          switch (record['CATEGORY']) {
            case 'GA':
              return '全聯會代表';
            case 'BDS':
              return '理監事名單';
            case 'SG':
              return '秘書處名單';
            case 'STC':
              return '專門委員會';
            case 'SFC':
              return '專業領域委員會';
            case 'SUBGRP':
              return '社團';
            case 'GRP':
              return '群組';
            case 'NL':
              return '名單';
            case 'SC':
              return '特別委員會';
            default:
              return record['CATEGORY'];
          }
        })();
        return display;
      },
    },
    {
      title: '屆別',
      key: 'GROUP_CURRENT',
      dataIndex: 'GROUP_CURRENT',
    },
    {
      title: '成立日期',
      key: 'EFF_DATE',
      dataIndex: 'EFF_DATE',
      render: (_, record) => {
        const display =
          formatDateStr(new Date(record['EFF_DATE'])) !== 'Invalid Date'
            ? formatDateStr(new Date(record['EFF_DATE']))
            : '';
        return display;
      },
    },
    {
      key: '',
      title: '',
      dataIndex: '',
      render: (_, item) => {
        return (
          <Button
            onClick={() => {
              data.onChange(item.id);
              onClose();
            }}>
            選擇
          </Button>
        );
      },
    },
  ];

  function onClose() {
    setKeyword(null);
    setRecords(null);
    // _setSelectedRows([]);
    setData(null);
  }

  return (
    <Modal
      visible={!!data}
      onCancel={onClose}
      footer={null}
      width={1000}
      closable={false}
      maskClosable={true}
      destroyOnClose={true}>
      <Wrapper>
        <Input.Search
          style={{marginBottom: 10}}
          placeholder="請輸入關鍵字"
          allowClear
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onSearch={async () => {
            let {total, results} = await fetchRecords(keyword, columns, {
              offset: 0,
              limit: pagination.pageSize,
            });
            setRecords(results);
            setPagination({...pagination, total});
          }}
        />

        <Table
          style={{marginBottom: 10}}
          scroll={{x: 500, y: 300}}
          pagination={{
            ...pagination,
            onChange: async (page, pageSize) => {
              let {total, results} = await fetchRecords(keyword, columns, {
                offset: (page - 1) * pageSize,
                limit: pageSize,
              });
              setRecords(results);
              setPagination({...pagination, total});
            },
          }}
          /*
          rowKey={(record) => record.owner}
          rowSelection={{
            type: 'radio',
            onChange: (selectedRowKeys, selectedRows) => {
              _setSelectedRows(selectedRows);
            },
          }}
          */
          columns={columns}
          dataSource={records}
        />
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled(ModalCustomStyle)``;
